import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import ShowConfiguration from '../../show-configuration';
import AppHeader from '../../header';
import AppLayoutComponent from '../common';
export default function ConfigurationPageContent() {
    return (_jsx(AppLayoutComponent, { forceToolsClosed: true, content: _jsxs(_Fragment, { children: [_jsx(AppHeader, { title: "Configuration" }, void 0),
                _jsx(ShowConfiguration, {}, void 0)] }, void 0) }, void 0));
}
